export default "__VITE_ASSET__Cuv9Z5R9__"